// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const { updateConsents } = require('actions/gdprConsents');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const {
  getCardStandard,
  getCreditCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  API_CHANNEL,
  CARD_PAYMENT_METHOD_FIXED,
  CARD_PAYMENT_METHOD_VARIABLE,
  CARD_REVOLVING_PRODUCT_SUBTYPE,
  CARD_REVOLVING_PRODUCT_TYPE,
  THIRD_STEP,
} = require('constants/index');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { recordLink, PROC_CARD_REVOLVING } = require('utilities/tagging');
const { REVOLVING_CARD_PRDOUCT_ALIAS } = require('constants/hiringProductInformation');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_RESET,
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hirePaymentMethodActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

function setAgreementCheckbox(evt) {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked: evt.target.checked,
    },
  };
}

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function validateAccount() {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_VALIDATE_ACCOUNT,
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid) {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
    },
  };
}

const taggingStep3 = immHirePaymentMethod => {
  let eventName = '';

  if (immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_FIXED) {
    eventName = 'pago aplazado cuota fija';
  } else if (immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_VARIABLE) {
    eventName = 'pago aplazado cuota variable';
  }

  recordLink(PROC_CARD_REVOLVING, eventName);

  if (immHirePaymentMethod.get('tooltipInfoShown')) {
    recordLink(PROC_CARD_REVOLVING, 'info forma de pago');
  }

  if (immHirePaymentMethod.get('tooltipVariablePaymentShown')) {
    recordLink(PROC_CARD_REVOLVING, 'info cuota variable');
  }

  if (immHirePaymentMethod.get('tooltipFixedPaymentShown')) {
    recordLink(PROC_CARD_REVOLVING, 'info cuota fija');
  }
};

const validateSecondStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  recordLink(
    PROC_CARD_REVOLVING,
    'personaliza tarjeta',
    immHireCardImageSelector.get('selectedImageId')
  );
  dispatch(validate(step, externalComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;
  const accountIsValid = getState().hireCardRevolving.getIn(['steps', step - 1, 'accountIsValid']);

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  if (
    allComponentsAreValid &&
    immHireCreditLimit.get('maxValueToAuthorize') > 0 &&
    immHireCreditLimit.get('creditLimit') > immHireCreditLimit.get('maxValueToAuthorize') &&
    immHireCreditLimit.get('minValue') < immHireCreditLimit.get('maxValueToAuthorize')
  ) {
    dispatch(hireCreditLimitActions.toggleModal(true));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }

  if (allComponentsAreValid) {
    taggingStep3(immHirePaymentMethod);
  }
};

const validateFourthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardRevolving.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const validateStep = step => (dispatch, getState) => {
  if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    const immCards = getState().cards;
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');

    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    dispatch(validateLoading(true));
    return APIPost({
      dispatch,
      endpoint: 'validateCardHire',
      params: {
        query: { cards: cardObj },
      },
    })
      .then(() => {
        dispatch(validateLoading(false));
    dispatch(validate(step, false));
      })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            dispatch(validate(step, true));
            dispatch(validateLoading(false));
          } else {
            dispatch(hireCardRevolvingFailure());
            dispatch(validateLoading(false));
          }
        }
      });
  } else if (step === 2) {
    //SECOND_STEP
    dispatch(hireCardImageSelectorActions.validateStep());
    dispatch(validateSecondStep(step));
  } else if (step === 3) {
    //THIRD_STEP
    dispatch(validateAccount());
    dispatch(hireCreditLimitActions.validateStep());
    dispatch(hirePaymentMethodActions.validateStep());
    dispatch(validateThirdStep(step));
  } else if (step === 4) {
    //FOURTH_STEP
    dispatch(validateFourthStep(step));
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }
  return dispatch(getStep(step));
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_REVOLVING_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const getScoringRequest = () => ({
  type: actionTypes.HIRE_CARD_REVOLVING_GET_SCORING_REQUEST,
});

const getScoringSuccess = response => ({
  type: actionTypes.HIRE_CARD_REVOLVING_GET_SCORING_SUCCESS,
  payload: {
    response,
  },
});

const getScoringFailure = error => ({
  type: actionTypes.HIRE_CARD_REVOLVING_GET_SCORING_FAILURE,
  payload: {
    error,
  },
});

const getScoring = () => dispatch => {
  // It sets the pack on success
  dispatch(getScoringRequest());
  return APIPost({
    dispatch,
    endpoint: 'segmentedActiveProducts',
  })
    .then(response => {
      dispatch(getScoringSuccess(response));
    })
    .catch(response => {
      if (!!response.error && !!response.error.description) {
        dispatch(getScoringFailure(response.error.description));
      } else {
        throw response;
      }
    });
};

const hireCardRevolvingRequest = () => ({
  type: actionTypes.HIRE_CARD_REVOLVING_REQUEST,
});

const hireCardRevolvingSuccess = hiringStatus => ({
  type: actionTypes.HIRE_CARD_REVOLVING_SUCCESS,
  payload: {
    hiringStatus,
  },
});

const hireCardRevolvingFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_CARD_REVOLVING_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_REVOLVING_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardRevolving = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireCardRevolvingRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardRevolvingFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardRevolvingSuccess(status.hiringStatus));
        dispatch(setTermsAndCondsInfo(REVOLVING_CARD_PRDOUCT_ALIAS, termsAndsCondsHiringData));
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardRevolvingFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardRevolvingFailure());
      } else {
        throw response;
      }
    });
};

const hireCardRevolving = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardRevolving.getIn(['steps', THIRD_STEP, 'accountId']);
    const accountInfo = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const selectedImageId = getCardStandard(
      getState().hireCardImageSelector.get('selectedImageId')
    );
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    let addressDetails = null;
    let numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: accountInfo,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        // todo nombreAdicional value
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: selectedImageId,
          subTipo: CARD_REVOLVING_PRODUCT_SUBTYPE,
          tipo: CARD_REVOLVING_PRODUCT_TYPE,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: selectedImageId,
        subType: CARD_REVOLVING_PRODUCT_SUBTYPE,
        type: CARD_REVOLVING_PRODUCT_TYPE,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardRevolving(dispatch, data, termsAndsCondsHiringData))
      .catch(response => {
        if (!!response.error) {
          setCardRevolving(dispatch, data, termsAndsCondsHiringData);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  getScoring,
  hireCardRevolving,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validate,
  validateStep,
};
